/**
 * Hook timeline communication unifiée.
 * Consomme l'endpoint backend qui agrège emails + notes (+ RDV vague 3).
 */
import { useQuery } from '@tanstack/react-query';
import { api } from '../../../lib/api.js';
import type { ApprenantNote } from '../../notes/hooks/useApprenantNotes.js';

export type TimelineEventKind = 'email' | 'note' | 'rdv';

export interface EmailDTO {
  id: string;
  apprenantZohoId: string | null;
  category: string;
  templateCode: string | null;
  fromEmail: string;
  toEmail: string;
  subject: string;
  bodyHtml: string;
  provider: string;
  providerMessageId: string | null;
  status: string;
  errorMessage: string | null;
  sentAt: string;
  openedAt: string | null;
  clickedAt: string | null;
  bouncedAt: string | null;
  metadata: Record<string, unknown> | null;
}

export interface TimelineEvent {
  kind: TimelineEventKind;
  at: string;
  apprenantId: string | null;
  email?: EmailDTO;
  note?: ApprenantNote;
}

export interface UseTimelineOpts {
  apprenantId?: string;
  kinds?: TimelineEventKind[];
  limit?: number;
}

export function useCommunicationTimeline(opts: UseTimelineOpts = {}) {
  const params = new URLSearchParams();
  if (opts.apprenantId) params.set('apprenantId', opts.apprenantId);
  if (opts.kinds?.length) params.set('kinds', opts.kinds.join(','));
  if (opts.limit) params.set('limit', String(opts.limit));
  const qs = params.toString();

  return useQuery({
    queryKey: ['v2', 'communications', 'timeline', opts] as const,
    queryFn: () =>
      api.get<TimelineEvent[]>(`/api/v1/v2/communications/timeline${qs ? `?${qs}` : ''}`),
  });
}
